module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento5.840a12c8.svg";